import { useContext } from "react";
import { Context } from "../context";
import Head from "next/head";
import { breakpoint0 } from "../utils/styles";

const Breadcrumbs = ({ type, slug, category, title, official = true }) => {
  const { theme } = useContext(Context);
  let primaryHref;
  let primaryLabel;
  let secondaryHref;
  let secondaryLabel;
  let targetHref = `/${type}/${slug}`;

  if (["get", "review"].includes(type)) {
    primaryHref = "/game/category/all";
    primaryLabel = "Games";
    secondaryHref = `/category/${category.slug}`;
    secondaryLabel = category.name;
  } else if (["article"].includes(type)) {
    primaryHref = "/articles";
    primaryLabel = "Articles";
    secondaryHref = `/articles/${category.slug}`;
    secondaryLabel = category.name;
  } else {
    throw new Error(`Unexpected content type ${type}`);
  }

  const schema = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@id": `https://www.appcheeta.com${primaryHref}`,
          name: primaryLabel,
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@id": `https://www.appcheeta.com${secondaryHref}`,
          name: secondaryLabel,
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@id": `https://www.appcheeta.com${targetHref}`,
          name: title,
        },
      },
    ],
  };

  return (
    <div className="breadcrumbs">
      <style jsx>{`
        .breadcrumbs {
          margin: 0.5rem 0;
          color: ${theme.secondaryTextColor};
          display: none;
          justify-content: space-between;
        }
        .breadcrumbs a {
          margin: 0 1rem;
          color: ${theme.secondaryTextColor};
          text-underline-position: under;
        }
        .breadcrumbs a:hover {
          color: ${theme.primaryTextColor};
        }
        .breadcrumbs a:first-child {
          margin-left: 0;
        }
        @media screen and (min-width: ${breakpoint0}) {
          .breadcrumbs {
            display: flex;
          }
        }
      `}</style>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          key="breadcrumb-schema"
        />
      </Head>
      <div className="left">
        <a href={primaryHref}>{primaryLabel}</a>/<a href={secondaryHref}>{secondaryLabel}</a>/
        <a href={targetHref}>{title}</a>
      </div>
      <div className="right">
        {["review", "game"].includes(type) && official && <a href="#links">Official Links</a>}
      </div>
    </div>
  );
};

export default Breadcrumbs;
